var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showModal)?_c('z-confirm',{attrs:{"primary-action-type":"danger","primary-action-label":`Yes, remove ${_vm.fullName || _vm.email}`,"title":`Remove ${_vm.fullName || _vm.email}`,"subtitle":`Are you sure you want to remove ${
    _vm.fullName || _vm.email
  } from the team? The user will loose all access to repositories and issues on DeepSource.`},on:{"primaryAction":_vm.removeMember,"onClose":_vm.close}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }